import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flag } from "lucide-react";
import { toast } from "sonner";
import { ConfirmDialog } from "../ConfirmDialog";
import { useAuth } from "../../../context/AuthContext";
import { supabase } from "../../../lib/supabase";

export function FlagButton({ profileId }) {
  const { user } = useAuth();
  const [counts, setCounts] = useState({ open: 0, total: 0 });
  const [action, setAction] = useState(null);
  const load = useCallback(async () => {
    const { data } = await supabase.from("reports").select("status").eq("profile_id", profileId);
    setCounts({ open: (data || []).filter((r) => r.status === "open").length, total: (data || []).length });
  }, [profileId]);
  useEffect(() => { load(); }, [load]);
  const flag = () => setAction({
    title: "Flag this profile", description: "The flag appears in Reports & Flags for follow-up.", needsReason: true, confirmLabel: "Flag profile",
    run: async (reason) => {
      const { error } = await supabase.from("reports").insert({ profile_id: profileId, reported_by: user.id, reason });
      if (error) toast.error(error.message); else { toast.success("Profile flagged"); load(); }
    },
  });
  return (
    <div className="flex items-center gap-2">
      <Link to="/admin/reports" data-testid="flag-count" className={`rounded-full px-3 py-1.5 text-xs font-semibold ${counts.open ? "bg-red-50 text-red-800" : "bg-stone-100 text-stone-600"}`}>
        <Flag className="mr-1 inline h-3 w-3" />{counts.open} open / {counts.total} flags
      </Link>
      <button type="button" onClick={flag} data-testid="flag-profile-button" className="rounded-full border border-[#A31828]/40 px-3 py-1.5 text-xs font-semibold text-[#A31828] hover:bg-red-50">Flag</button>
      <ConfirmDialog action={action} onClose={() => setAction(null)} />
    </div>
  );
}
